import { createContext } from "react";
const StreamingStatusContext = createContext(false);
export { StreamingStatusContext };
